<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid >
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12" v-if="!complete">
							<v-toolbar dark color="primary">
								<v-toolbar-title>Register</v-toolbar-title>
							</v-toolbar>
							<v-card-text>
								<v-form>
									<v-text-field prepend-icon="fas fa-user" name="email"
										v-validate="'required|email'" :error-messages="errors.collect('email')" required
										label="Email" type="text" v-model="auth.username"></v-text-field>
									<v-text-field id="password" prepend-icon="fas fa-lock"
										:append-icon="pwVisible ? 'far fa-eye' : 'far fa-eye-slash'"
										:type="pwVisible ? 'text' : 'password'"
										@click:append="pwVisible = !pwVisible"
										v-validate="'required'" :error-messages="errors.collect('password')" required
										name="password" label="Password" v-model="auth.password"></v-text-field>
								</v-form>
								<v-alert :value="serverDown" type="error">
									Server unavailable
								</v-alert>
								<v-alert :value="invalid" type="warning">
									That username is already in use
								</v-alert>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="register" :loading="registering"
									:disabled="errors.any() || registering">Login</v-btn>
							</v-card-actions>
						</v-card>
						<v-card class="elevation-12" v-else>
							<v-toolbar dark color="success">
								<v-toolbar-title>Success</v-toolbar-title>
							</v-toolbar>
							<v-card-text class="py-5">
								Account created. Please check your email to confirm your account before logging in.
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import analysisApi from "../analysisApi";

export default {
	data() {
		return {
			auth: {
				username: null,
				password: null,
				token: this.$route.params.token,
			},
			pwVisible: false,
			invalid: false,
			serverDown: false,
			registering: false,
			complete: false,
		};
	},
	mounted() {
		this.$validator.validateAll();
	},
	methods: {
		register() {
			this.invalid = false;
			this.serverDown = false;
			this.registering = true;

			analysisApi.register(this.auth).then(() => {
				this.registering = false;
				this.complete = true;
			}).catch((e) => {
				this.registering = false;

				if (!e.response || e.response.status === 404 || (e.response.status >= 500 && e.response.status <= 599)) {
					//Not found or any server error codes
					this.serverDown = true;
				} else {
					//Invalid login
					this.invalid = true;
				}
			});
		},
	},
};
</script>
